// @ts-ignore
import templateHtml from './obq.template.html';

export class OBQService {
  isOpen = false;
  hasAnswers = false;

  _user = null;

  _OBQQuestions;
  /** @type {ng.ui.bootstrap.IModalService} */
  _$uibModal;
  _$errorReporter;

  /**
   * @param {import("./obq-questions.value").OBQQuestion[]} OBQQuestions
   * @param {ng.ui.bootstrap.IModalService} $uibModal
   * @param {import('stackdriver-errors-js').default['report']} $errorReporter
   */
  constructor (
    OBQQuestions,
    $uibModal,
    $errorReporter,
  ) {
    this._OBQQuestions = OBQQuestions;
    this._$uibModal = $uibModal;
    this._$errorReporter = $errorReporter;
  }

  setUser(user) {
    this._user = user;
    this.hasAnswers = this.unansweredQuestions().length === 0;
  };

  getUser() {
    return this._user;
  };

  /**
   * Returns OBQ questions that the user has not yet answered.
   * @return {import("./obq-questions.value").OBQQuestion[]};
   */
  unansweredQuestions() {
    var user = this.getUser();
    if (!user) return [];

    let unanswered = [];

    this._OBQQuestions
      .forEach(function(question) {
        if (!user.obq || !user.obq[question.slug]) {
          unanswered.push(question);
        }
    });

    return unanswered;
  }

  openModal() {
    var service = this;
    var $errorReporter = service._$errorReporter;
    this.isOpen = true;

    return this._$uibModal.open({
      template: templateHtml,
      controller:
        /**
         * @param {any} $scope
         * @param {ng.ui.bootstrap.IModalInstanceService} $uibModalInstance
         */
        ($scope, $uibModalInstance) => {
          $scope.questions = service.unansweredQuestions();

          $scope.obqAnswers =
            $scope.questions
              .map(function(entry) {
                return [entry.slug, null];
              })
              .reduce(function(acc, entry) {
                acc[entry[0]] = null;

                return acc;
              }, {});


          $scope.canSubmit = function() {
            var hasAllResponses = true;

            Object.entries($scope.obqAnswers).forEach(function(entry) {
              if (!entry[1]) hasAllResponses = false;
            });

            return hasAllResponses;
          };

          $scope.handleSkipClicked = function() {
            var skipAll = {};

            Object.entries($scope.obqAnswers).forEach(function(entry) {
              skipAll[entry[0]] = 'skip';
            });

            $uibModalInstance.close(skipAll);
          };

          $scope.handleSaveClicked = function() {
            $uibModalInstance.close($scope.obqAnswers);
          };
        },
    }).result.then(function(result) {
      service.isOpen = false;

      return result;
    }).catch(function(err) {
      service.isOpen = false;

      $errorReporter(new Error(err));
      return null;
    });
  }; /* openModal */
}

export default [
  'OBQQuestions',
  '$uibModal',
  '$errorReporter',
  OBQService,
];


